// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1ps3m","label":"Completed_label__3T15v"};